import { FC, ReactNode } from 'react'
import { NavLink } from 'react-router-dom'
import { Button } from '@mui/material'

export interface ButtonLinkProps {
  to?: string
  children: string | ReactNode
  // eslint-disable-next-line
  [propName: string]: any
}

export const ButtonLink: FC<ButtonLinkProps> = (props) => {
  const { to, children, ...args } = props
  if (to) {
      return (
        <NavLink to={to}>
          <Button {...args}>{children}</Button>
        </NavLink>
    )
  }
  return <Button {...args}>{children}</Button>
}
